import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject, isDevMode } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { catchError, Observable, switchMap, throwError } from 'rxjs';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    const router = inject(Router);
    let newReq = req.clone({ withCredentials: true });
    // Clone the request object
    // let newReq = req.clone();
    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.

    /* Not needed because we will be using withCredentials */
    if (isDevMode()) {
        if (
            authService.accessToken &&
            !AuthUtils.isTokenExpired(authService.accessToken)
        ) {
            newReq = newReq.clone({
                headers: newReq.headers.set(
                    'Authorization',
                    'Bearer ' + authService.accessToken
                ),
            });
        }
    }
    // Response
    return next(newReq).pipe(
        catchError((error) => {
            // Catch "401 Unauthorized" responses
            if (error instanceof HttpErrorResponse && error.status === 401) {
                // Sign out
                return authService.signOut(true).pipe(
                    switchMap(() => {
                        router.navigate(['sign-in']);
                        return throwError(() => error);
                    })
                );

                // Reload the app
                //location.reload();
            }

            return throwError(() => error);
        })
    );
};
